import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=39636cdc&scoped=true&"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39636cdc",
  null
  
)

export default component.exports